import {Button, Divider, Form, Input, notification, Upload} from "antd";
import {DatePicker, JalaliLocaleListener} from "antd-jalali";
import locale from "antd/es/date-picker/locale/fa_IR";
import React, {useContext, useState} from "react";
import {validateIranianMobile, validateIranianNationalCode} from "./validation";
import {FormProps} from "./types";
import {UploadOutlined} from "@ant-design/icons";
import {RcFile} from "antd/es/upload/interface";
import AuthContext from "../../utilis/contexts/AuthContext";
const { TextArea } = Input;
const RealPersonForm=({onConfirm,loading}:FormProps)=>{

    const [form] = Form.useForm();
    const [date,setDate]=useState<string | null>(null);
    const [fileBase64, setFileBase64] = useState<string | null>(null);
    const [fileList,setFileList]=useState<RcFile[]>([])
    const authContext=useContext(AuthContext)
    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleBeforeUpload = async (file: RcFile): Promise<boolean> => {
        const isPdf = file.type === 'application/pdf';
        const isTif =
            file.type === 'image/tiff' ||
            file.name.endsWith('.tif') ||
            file.name.endsWith('.tiff');

        if (!isPdf && !isTif) {
            notification.error({
                message: 'تنها مجاز به ارسال فایل با فرمت tif , pdf می باشید.',
                duration: 5,
            });
            return false;
        }

        const base64 = await getBase64(file);
        setFileBase64(base64);
        setFileList([file]); // ✅ Add file manually only if valid
        return false; // Prevent auto-upload
    };
    const handleRemoveFileList=()=>{
        setFileBase64(null)
        setFileList([]);
    }
    const handleSubmit=(value:any)=>{
        if(!fileBase64){
            notification['error']({
                message: 'فایل درخواست را انتخاب کنید',
                duration: 120
            });
            return;
        }
        const data={
            Attachment:fileBase64,
            Name:value.name,
            Subject:value.subject,
            BirthDate:date,
            NationalCode:value.nationalCode,
            Address:value.address,
            Mobile:value.mobile,
            FatherName:value.fatherName,
        }
        onConfirm(data)
    }

    return <div>
        <JalaliLocaleListener/>
        <Form

            name="realForm"
            className="w-full grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2"
            layout='vertical'
            onFinish={handleSubmit}
            form={form}
            initialValues={{
                mobile: authContext?.user?.cellphone||'',
                name: authContext?.user?.name||'',
                birthDate: '',
                subject: '',
                nationalCode: '',
                address: '',
                fatherName:''

            }}

            autoComplete="off" scrollToFirstError={true}
        >
            <Form.Item
                className="col-span-1"
                label="نام و نام خانوادگی "
                name="name"
                rules={[{required: true, message: 'نام و نام خانوادگی الزامی است.'}]}
            >
                <Input placeholder="نام و نام خانوادگی را وارد کنید." size="large"/>
            </Form.Item>
            <Form.Item
                className="col-span-1"
                label="نام پدر"
                name="fatherName"
                rules={[{required: true, message: 'نام پدر الزامی است.'}]}
            >
                <Input placeholder="نام پدر را وارد کنید." size="large"/>
            </Form.Item>
            <Form.Item className="col-span-2 lg:col-span-1 xl:col-span-2"
                label="شماره موبایل"
                name="mobile"
                rules={[
                    {required: true, message: 'شماره موبایل  الزامی است.'},
                    {validator: validateIranianMobile},
                ]}
            >
                <Input placeholder="شماره موبایل را وارد کنید" type="tel" size="large"/>
            </Form.Item>

            <Form.Item
                label="کد ملی"
                name="nationalCode"
                rules={[
                    {required: true, message: 'کدملی الزامی است.'},
                    {validator: validateIranianNationalCode},
                ]}
                className="w-full"
            >
                <Input
                    type="tel"
                    placeholder="کد ملی را وارد کنید"
                    className="w-full"
                    size="large"
                />
            </Form.Item>

            <Form.Item
                className="col-span-1"
                label="تاریخ تولد"
                name="birthDate"
                rules={[{required: true, message: 'تاریخ تولد الزامی است.'}]}
            >
                <DatePicker
                    format="YYYY/MM/DD"
                    onChange={(value: any, persian: any) => {
                        setDate(persian);
                    }}
                    className="w-full"
                    size="large"
                    nextIcon={<></>}
                    locale={locale}
                />
            </Form.Item>

            <Form.Item
                className="col-span-2 "
                label="نشانی محل سکونت"
                name="address"
                rules={[{required: true, message: 'نشانی محل سکونت الزامی است.'}]}
            >
                <Input
                    type="text"
                    placeholder="نشانی محل سکونت وارد کنید"
                    className="w-full"
                    size="large"
                />
            </Form.Item>

            <Form.Item
                className="col-span-2 lg:col-span-3 xl:col-span-4"
                label="موضوع درخواست"
                name="subject"
                rules={[{required: true, message: 'موضوع درخواست الزامی است.'}, {
                    min: 10,
                    message: 'موضوع درخواست حداقل باید 10 کاراکتر باشد'
                }]}
            >
                <TextArea

                    maxLength={500}
                    placeholder="موضوع درخواست را وارد کنید"
                    className="w-full"
                    size="large"
                />
            </Form.Item>

            <div className="col-span-2 ">
                <Upload className="w-full" onRemove={handleRemoveFileList} fileList={fileList}  maxCount={1} beforeUpload={handleBeforeUpload} showUploadList={true}>
                    <Button className="flex w-full bg-gray-100 rounded-lg  justify-center items-center flex-col">
                        فایل درخواست
                        <UploadOutlined/>
                    </Button>
                </Upload>

            </div>
            <div className="col-span-2 lg:col-span-3 xl:col-span-4">
                <Divider/>
            </div>
            <Form.Item className="col-span-2 lg:col-span-1"><Button loading={loading} className="w-full" size="large" type="primary" htmlType="submit">ثبت
                اطلاعات</Button></Form.Item>

        </Form>
    </div>
}
export default RealPersonForm;